import type { DynamicPropertyValueType, Property, InputDynamicPropertyValueType } from "@/core/api/graphql/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDynamicPropertyValue<T = any>(
  obj: DynamicPropertyValueType[] | Property[] | undefined,
  dynamicProperty: string,
): T | undefined {
  if (!obj || !Array.isArray(obj)) {
    return undefined;
  }

  const targetObject = obj.find((item) => item.name && item.name === dynamicProperty);
  return targetObject ? (targetObject.value as T) : undefined;
}

export function updateDynamicProperties(
  propName: string,
  propValue: string | number,
  dynamicProperties: InputDynamicPropertyValueType[],
) {
  const newProperty = [{ name: propName, value: propValue }];

  dynamicProperties = dynamicProperties.map((existingObj) => {
    const updatedObject = newProperty.find((newObj) => newObj.name === existingObj.name);
    return updatedObject ? updatedObject : existingObj;
  });
  newProperty.forEach((newObj) => {
    if (!dynamicProperties.some((existingObj) => existingObj.name === newObj.name)) {
      dynamicProperties.push(newObj);
    }
  });

  return dynamicProperties;
}
